<div class="dialog-container">
  <ngx-spinner [zIndex]=100 name="spPeriodoContrato" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
    type="ball-atom" [fullScreen]="false">
  </ngx-spinner>

  <button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h1 mat-dialog-title>
    Ver <strong>período</strong>
    <span class="subtitulo" *ngIf="periodoContratoDetail">
      {{ periodoContratoDetail.periodoMes }}/{{ periodoContratoDetail.periodoAnio }}-{{ periodoContratoDetail.periodo }}
    </span>
  </h1>
  <mat-divider></mat-divider>
  <br>

  <div mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="periodoContratoDetail">

    <mat-tab-group animationDuration="0ms">

      <!-- ============================ DATOS GENERALES ============================ -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">info</mat-icon>
          Datos Generales
        </ng-template>

        <div class="tab-content">

          <!-- IMPORTES -->
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">payments</mat-icon>
              <h3>Importes</h3>
            </div>
            <mat-divider></mat-divider>

            <div class="row mt-3">
              <div class="col-lg-3">
                <span class="label">Importe Alquiler</span>
                <span class="value importe">{{ periodoContratoDetail.importeAlquiler | currency }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Descuento</span>
                <span class="value">{{ periodoContratoDetail.descuento | currency }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Incremento</span>
                <span class="value">{{ periodoContratoDetail.incremento | currency }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Importe Anterior</span>
                <span class="value">{{ periodoContratoDetail.importeAlquilerAnterior ? (periodoContratoDetail.importeAlquilerAnterior | currency) : '-' }}</span>
              </div>
            </div>
          </mat-card>

          <!-- AJUSTE -->
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">trending_up</mat-icon>
              <h3>Ajuste</h3>
            </div>
            <mat-divider></mat-divider>

            <div class="row mt-3">
              <div class="col-lg-3">
                <span class="label">Estado</span>
                <span class="value">
                  <mat-chip-list>
                    <mat-chip *ngIf="periodoContratoDetail.ajusteProcesado" color="primary" selected>Procesado</mat-chip>
                    <mat-chip *ngIf="!periodoContratoDetail.ajusteProcesado">Pendiente</mat-chip>
                  </mat-chip-list>
                </span>
              </div>
              <div class="col-lg-3">
                <span class="label">Tipo de Ajuste</span>
                <span class="value">{{ periodoContratoDetail.indiceAjusteContrato?.tipoAjusteContrato?.acronimo | uppercase }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Valor Ajuste</span>
                <span class="value">{{ periodoContratoDetail.valorAjuste | number:'1.3-3' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Fecha Ajuste</span>
                <span class="value">{{ esFechaValida(periodoContratoDetail.fechaAjuste) ? (periodoContratoDetail.fechaAjuste | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-lg-3">
                <span class="label">Valor Índice</span>
                <span class="value">{{ periodoContratoDetail.indiceAjusteContrato?.valor ?? '-' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Fecha Índice</span>
                <span class="value">{{ periodoContratoDetail.indiceAjusteContrato?.fecha ? (periodoContratoDetail.indiceAjusteContrato?.fecha | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
            </div>
          </mat-card>

          <!-- ESTADO DEL PERIODO -->
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">event_available</mat-icon>
              <h3>Estado del Período</h3>
            </div>
            <mat-divider></mat-divider>

            <div class="row mt-3">
              <div class="col-lg-3">
                <span class="label">Fecha Vencimiento</span>
                <span class="value">{{ esFechaValida(periodoContratoDetail.fechaVencimiento) ? (periodoContratoDetail.fechaVencimiento | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Fecha Pago</span>
                <span class="value">{{ esFechaValida(periodoContratoDetail.fechaPago) ? (periodoContratoDetail.fechaPago | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Fecha Liquidación</span>
                <span class="value">{{ esFechaValida(periodoContratoDetail.fechaLiquidacion) ? (periodoContratoDetail.fechaLiquidacion | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
              <div class="col-lg-3">
                <span class="label">Fecha Adenda</span>
                <span class="value">{{ esFechaValida(periodoContratoDetail.fechaAdenda) ? (periodoContratoDetail.fechaAdenda | date:'dd/MM/yyyy') : '-' }}</span>
              </div>
            </div>

            <div class="row mt-3" *ngIf="periodoContratoDetail.descripcion">
              <div class="col-lg-12">
                <span class="label">Descripción</span>
                <span class="value">{{ periodoContratoDetail.descripcion }}</span>
              </div>
            </div>
          </mat-card>

        </div>
      </mat-tab>

      <!-- ============================== COMPROBANTES ============================== -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">receipt_long</mat-icon>
          Comprobantes
          <span class="badge-contador" *ngIf="comprobantesVinculados.length > 0">{{ comprobantesVinculados.length }}</span>
        </ng-template>

        <div class="tab-content">
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">account_tree</mat-icon>
              <h3>Trazabilidad</h3>
            </div>
            <mat-divider></mat-divider>

            <app-sin-datos *ngIf="comprobantesVinculados.length === 0"
              icono="link_off"
              mensaje="Sin comprobantes vinculados"
              detalle="Este período todavía no se cobró ni se liquidó."
              [compacto]="true">
            </app-sin-datos>

            <table mat-table [dataSource]="comprobantesVinculados" class="mt-3 w-100"
              *ngIf="comprobantesVinculados.length > 0">

              <ng-container matColumnDef="tipoComprobante">
                <th mat-header-cell *matHeaderCellDef>Tipo</th>
                <td mat-cell *matCellDef="let element">
                  <span class="with-icon">
                    <mat-icon color="primary">description</mat-icon>
                    {{ element.tipoComprobante || '-' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="nroComprobante">
                <th mat-header-cell *matHeaderCellDef>Nro.</th>
                <td mat-cell *matCellDef="let element">{{ element.nroComprobante || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="fechaEmision">
                <th mat-header-cell *matHeaderCellDef>Fecha</th>
                <td mat-cell *matCellDef="let element">{{ element.fechaEmision | date:'dd/MM/yyyy' }}</td>
              </ng-container>

              <ng-container matColumnDef="estadoComprobante">
                <th mat-header-cell *matHeaderCellDef>Estado</th>
                <td mat-cell *matCellDef="let element">{{ element.estadoComprobante || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="importeImputado">
                <th mat-header-cell *matHeaderCellDef class="text-right">Importe imputado</th>
                <td mat-cell *matCellDef="let element" class="text-right">
                  {{ element.importeImputado != null ? (element.importeImputado | currency) : '-' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="accion">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <button mat-icon-button color="primary" (click)="verComprobante(element)"
                    matTooltip="Ver comprobante">
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsComprobantes"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumnsComprobantes;"></tr>
            </table>
          </mat-card>
        </div>
      </mat-tab>

      <!-- =============================== AUDITORÍA =============================== -->
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="tab-icon">history</mat-icon>
          Auditoría
        </ng-template>

        <div class="tab-content">
          <mat-card class="mb-3 p-3">
            <div class="section-title">
              <mat-icon color="primary">history</mat-icon>
              <h3>Información de auditoría</h3>
            </div>
            <mat-divider></mat-divider>

            <div class="row mt-3">
              <div class="col-lg-6">
                <span class="label">Fecha Alta</span>
                <span class="value">{{ esFechaValida(periodoContratoDetail.fechaAlta) ? (periodoContratoDetail.fechaAlta | date:'dd/MM/yyyy HH:mm') : '-' }}</span>
              </div>
              <div class="col-lg-6">
                <span class="label">Fecha Modificación</span>
                <span class="value">{{ esFechaValida(periodoContratoDetail.fechaModificacion) ? (periodoContratoDetail.fechaModificacion | date:'dd/MM/yyyy HH:mm') : '-' }}</span>
              </div>
            </div>
          </mat-card>
        </div>
      </mat-tab>

    </mat-tab-group>
  </div>

  <div mat-dialog-actions>
    <button mat-button (click)="closeDialog()" color="warn">Cerrar</button>
  </div>
</div>
